import React, { useState } from "react";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { requestPasswordReset } from "../api/users";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ForgotPasswordPage = () => {
    const { t } = useTranslation("common");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage(null);

        try {
            await requestPasswordReset(email);
            setMessage(t("forgotPassword.success"));
        } catch (err) {
            setError(err.message || t("forgotPassword.error"));
        }
    };

    const isSent = Boolean(message);

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
            }}
        >
            <Box sx={{
                maxWidth: 400,
                width: "100%",
                p: 4,
                boxShadow: 3,
                borderRadius: 2,
                textAlign: "center",
                backgroundColor: "white"
            }}>
                <Typography variant="h5" fontWeight="bold" mb={3}>
                    {t("forgotPassword.title")}
                </Typography>

                {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email"
                        type="email"
                        fullWidth
                        required
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ mb: 2 }}
                        disabled={isSent}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={isSent}
                    >
                        {t("forgotPassword.submit")}
                    </Button>
                </form>
                {isSent && (
                <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={() => navigate("/")}
                >
                    {t("forgotPassword.backHome")}
                </Button>
                )}
            </Box>
        </Box>
    );
};

export default ForgotPasswordPage;
